'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class, _descriptor, _descriptor2;

var _mobx = require('mobx');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  Object.defineProperty(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var InsurerStore = (_class = function () {
  function InsurerStore(caseStore, transport) {
    _classCallCheck(this, InsurerStore);

    _initDefineProp(this, 'insurerOptions', _descriptor, this);

    _initDefineProp(this, 'queryResults', _descriptor2, this);

    this.caseStore = caseStore;
    this.transport = transport;
  }

  _createClass(InsurerStore, [{
    key: 'create',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var caseId = _ref2.caseId,
            insurerData = _ref2.insurerData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.transport.post('/insurers/', { data: insurerData });

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function create(_x) {
        return _ref.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: 'retrieve',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return', null);

              case 2:
                _context2.next = 4;
                return this.transport.get('/insurers/:id/', { urlParams: { id: id } });

              case 4:
                return _context2.abrupt('return', _context2.sent);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function retrieve(_x2) {
        return _ref3.apply(this, arguments);
      }

      return retrieve;
    }()
  }, {
    key: 'update',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5) {
        var caseId = _ref5.caseId,
            insurerData = _ref5.insurerData,
            type = _ref5.type;
        var data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                data = _defineProperty({}, type + '_insurer', insurerData);
                _context3.next = 3;
                return this.caseStore.update({ caseId: caseId, data: data });

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function update(_x3) {
        return _ref4.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: 'remove',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref7) {
        var caseId = _ref7.caseId,
            type = _ref7.type;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.caseStore.update({ caseId: caseId, data: _defineProperty({}, type + '_insurer', null) });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function remove(_x4) {
        return _ref6.apply(this, arguments);
      }

      return remove;
    }()
  }, {
    key: 'upsert',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_case, insurerData, _ref9) {
        var type = _ref9.type;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(insurerData === null && _case[type + '_insurer'])) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 3;
                return this.remove({ caseId: _case.id, type: type });

              case 3:
                _context5.next = 19;
                break;

              case 5:
                if (!(insurerData && !insurerData.id)) {
                  _context5.next = 12;
                  break;
                }

                insurerData.id = _uuid2.default.v4();
                _context5.next = 9;
                return this.create({ caseId: _case.id, insurerData: insurerData });

              case 9:
                return _context5.abrupt('return', _context5.sent);

              case 12:
                if (!((0, _get3.default)(insurerData, 'id') === (0, _get3.default)(_case, type + '_insurer.id'))) {
                  _context5.next = 16;
                  break;
                }

                return _context5.abrupt('return');

              case 16:
                if (!(insurerData && insurerData.name)) {
                  _context5.next = 19;
                  break;
                }

                _context5.next = 19;
                return this.update({ caseId: _case.id, insurerData: insurerData.id, type: type });

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function upsert(_x5, _x6, _x7) {
        return _ref8.apply(this, arguments);
      }

      return upsert;
    }()
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return InsurerStore;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'insurerOptions', [_mobx.observable], {
  enumerable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'queryResults', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, 'create', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'create'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'retrieve', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'retrieve'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'update', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'update'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'remove', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'remove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'upsert', [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, 'upsert'), _class.prototype)), _class);
var _default = InsurerStore;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(InsurerStore, 'InsurerStore', '/app/src/stores/InsurerStore.js');
  reactHotLoader.register(_default, 'default', '/app/src/stores/InsurerStore.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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